"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contactList = void 0;
const enums_1 = require("../../contracts/enums");
exports.contactList = [
    {
        _id: "shareholder-1",
        contact: {
            _id: "contacts-1",
            firstName: "Ali",
            secondName: "",
            thirdName: "",
            familyName: "Barber",
            email: "ali@mail.com",
            phone: { dialCode: "+61", phoneNumber: "4111111111" },
        },
        contactPersonCount: 1,
        entityType: enums_1.EntityType.INDIVIDUAL,
        legalEntityName: "Ali Barber",
        name: "alibarber",
        trusteeType: null,
    },
    {
        _id: "shareholder-2",
        contact: {
            _id: "contacts-2",
            firstName: "Ali",
            secondName: "",
            thirdName: "",
            familyName: "Barber",
            email: "ali@mail.com",
            phone: { dialCode: "+61", phoneNumber: "4111111111" },
        },
        contactPersonCount: 1,
        entityType: enums_1.EntityType.COMPANY,
        legalEntityName: "Ali Industries Pty Ltd",
        name: "alibarber",
        trusteeType: null,
    },
    {
        _id: "shareholder-3",
        contact: {
            _id: "contacts-3",
            firstName: "Jane",
            secondName: "Mary",
            thirdName: "",
            familyName: "Herbert",
            email: "jane@mail.com",
            phone: { dialCode: "+61", phoneNumber: "4111111113" },
        },
        contactPersonCount: 1,
        entityType: enums_1.EntityType.INDIVIDUAL,
        legalEntityName: "Jane Mary Herbert",
        name: "janemaryherbert",
        trusteeType: null,
    },
    {
        _id: "shareholder-4",
        contact: {
            _id: "contacts-4",
            firstName: "Kevin",
            secondName: "Harry",
            thirdName: "Simeon",
            familyName: "Campion",
            email: "kevin@mail.com",
            phone: { dialCode: "+61", phoneNumber: "4111111114" },
        },
        contactPersonCount: 1,
        entityType: enums_1.EntityType.INDIVIDUAL,
        legalEntityName: "Kevin Harry Simon Campion",
        name: "kevinharrysimeoncampion",
        trusteeType: null,
    },
    {
        _id: "shareholder-5",
        contact: {
            _id: "contacts-5",
            firstName: "Jenny",
            secondName: "Marie",
            thirdName: "Evelyn",
            familyName: "Campion",
            email: "jenny@mail.com",
            phone: { dialCode: "+61", phoneNumber: "4111111115" },
        },
        contactPersonCount: 1,
        entityType: enums_1.EntityType.TRUST,
        legalEntityName: "Campion Family Trust",
        name: "jennymarieevelyncampion",
        trusteeType: enums_1.TrusteeType.INDIVIDUAL,
    },
    {
        _id: "shareholder-6",
        contact: {
            _id: "contacts-6",
            firstName: "Martin",
            secondName: "Jon",
            thirdName: "Hector",
            familyName: "Everett",
            email: "martin@mail.com",
            phone: { dialCode: "+61", phoneNumber: "4111111116" },
        },
        contactPersonCount: 1,
        entityType: enums_1.EntityType.TRUST,
        legalEntityName: "Everett Family Trust",
        name: "martinjonhectoreverett",
        trusteeType: enums_1.TrusteeType.COMPANY,
    },
    {
        _id: "shareholder-7",
        contact: {
            _id: "contacts-7",
            firstName: "Sally",
            secondName: "",
            thirdName: "",
            familyName: "Huon",
            email: "sally@mail.com",
            phone: { dialCode: "+61", phoneNumber: "4111111117" },
        },
        contactPersonCount: 2,
        entityType: enums_1.EntityType.SMSF,
        legalEntityName: "Sally Huon, Margaret Huon ATF Huon Trust",
        name: "sallyhuon",
        trusteeType: enums_1.TrusteeType.INDIVIDUAL,
    },
    {
        _id: "shareholder-8",
        contact: {
            _id: "contacts-8",
            firstName: "George",
            secondName: "",
            thirdName: "",
            familyName: "Huon",
            email: "george@mail.com",
            phone: { dialCode: "+61", phoneNumber: "4111111118" },
        },
        contactPersonCount: 1,
        entityType: enums_1.EntityType.SMSF,
        legalEntityName: "George Huon",
        name: "georgehuon",
        trusteeType: enums_1.TrusteeType.COMPANY,
    },
    {
        _id: "shareholder-9",
        contact: {
            _id: "contacts-9",
            firstName: "Macie",
            secondName: "",
            thirdName: "",
            familyName: "Campion",
            email: "macie@mail.com",
            phone: { dialCode: "+61", phoneNumber: "4111111119" },
        },
        contactPersonCount: 1,
        entityType: enums_1.EntityType.INDIVIDUAL,
        legalEntityName: "Macie Campion",
        name: "maciecampion",
        trusteeType: null,
    },
    {
        _id: "shareholder-10",
        contact: {
            _id: "contacts-10",
            firstName: "Lucas",
            secondName: "",
            thirdName: "",
            familyName: "Campion",
            email: "lucas@mail.com",
            phone: { dialCode: "+61", phoneNumber: "4111111110" },
        },
        contactPersonCount: 1,
        entityType: enums_1.EntityType.INDIVIDUAL,
        legalEntityName: "Lucas Campion",
        name: "lucascampion",
        trusteeType: null,
    },
    {
        _id: "shareholder-11",
        contact: {
            _id: "contacts-11",
            firstName: "Jonas",
            secondName: "",
            thirdName: "",
            familyName: "Campion",
            email: "jonas@mail.com",
            phone: { dialCode: "+61", phoneNumber: "4111111111" },
        },
        contactPersonCount: 1,
        entityType: enums_1.EntityType.INDIVIDUAL,
        legalEntityName: "Jonas Campion",
        name: "jonascampion",
        trusteeType: null,
    },
];
//# sourceMappingURL=contactList.mock.js.map